import { MessageTypesEnum } from '../../../../typings/message-types';
import { QRAllowedMediaTypes } from '../../types/quick-reply';

export const getMediaTypeDisplayText = (type: string) => {
  switch (type) {
    case 'photo':
      return 'Photo';
    case 'image':
      return 'Photo';
    case 'video':
      return 'Video';
    case 'audio':
      return 'Audio';
    default:
      return 'PDF';
  }
};

export const getExtension = (name: string) => {
  if (name.includes('.pdf')) {
    return 'PDF';
  }
  return name?.split('.')?.pop();
};

export const getFileSize = (size: number) => {
  if (size < 1024) {
    return `${size}B`;
  }
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  }
  return `${(size / 1024 / 1024).toFixed(1)}MB`;
};

export const getMediaType = (file: File): 'photo' | 'video' | 'audio' | 'PDF' => {
  if (file.type.startsWith('image/')) return 'photo';
  if (file.type.startsWith('video/')) return 'video';
  if (file.type.startsWith('audio/')) return 'audio';
  if (file.type === 'application/pdf') return 'PDF'; // treat PDF as 'audio' for now (icon only)
  return 'photo';
};

export const getMediaTypeFromFileTypeName = (type: string): 'photo' | 'video' | 'audio' | 'PDF' => {
  if (type.startsWith('image/')) return 'photo';
  if (type.startsWith('video/')) return 'video';
  if (type === 'application/pdf') return 'PDF'; // treat PDF as 'audio' for now (icon only)
  return 'photo';
};

export const getMediaTypeFromFileObject = (file: File): QRAllowedMediaTypes => {
  if (file.type.startsWith('image/')) return QRAllowedMediaTypes.IMAGE;
  if (file.type.startsWith('video/')) return QRAllowedMediaTypes.VIDEO;
  if (file.type === 'application/pdf') return QRAllowedMediaTypes.DOCUMENT;
  if (file.type.startsWith('audio/')) return QRAllowedMediaTypes.AUDIO;
  return QRAllowedMediaTypes.IMAGE;
};

export const qRMediaTypeToMessageType = (mediaType: QRAllowedMediaTypes) => {
  switch (mediaType) {
    case 'image':
      return MessageTypesEnum.IMAGE;
    case 'video':
      return MessageTypesEnum.VIDEO;
    case 'audio':
      return MessageTypesEnum.AUDIO;
    case 'document':
      return MessageTypesEnum.DOCUMENT;
    default:
      return MessageTypesEnum.IMAGE;
  }
};
